// Push credential helpers that run in the browser (C-4 CredentialCreate):
// checking an APNs .p8 key or an FCM service-account file before it is
// sent. Nothing here keeps, logs or shows a private key: the forms send it
// once, as `secret`, and forget it. A VAPID pair is generated by notify
// itself (POST /notify/credentials/generate-vapid), never here.

export const base64url = bytes => {
  let binary = ''
  const view = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes)
  for (let i = 0; i < view.length; i++) binary += String.fromCharCode(view[i])
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

// Why a .p8 file isn't an APNs auth key, or null when it looks like one
// (a PKCS #8 PEM private key; the server parses it properly).
export const p8Problem = text =>
  /-----BEGIN PRIVATE KEY-----[\s\S]+-----END PRIVATE KEY-----/.test(String(text || ''))
    ? null
    : "That file isn't an APNs key. Use the AuthKey_<Key ID>.p8 file from your Apple Developer account."

// Apple names the download AuthKey_<Key ID>.p8.
export const keyIDFromFileName = name => {
  const m = /^AuthKey_([A-Z0-9]{10})\.p8$/i.exec(String(name || ''))
  return m ? m[1].toUpperCase() : ''
}

// The metadata an FCM service-account JSON file names (what the list will
// show after save), or an error when it isn't one. Its private key is never
// returned.
export const parseServiceAccount = text => {
  let json
  try {
    json = JSON.parse(text)
  } catch (e) {
    throw new Error("That file isn't a service-account key. Download a JSON key for the service account in the Firebase console.")
  }
  if (!json || json.type !== 'service_account' || !json.private_key || !json.client_email || !json.project_id) {
    throw new Error("That file isn't a service-account key. Download a JSON key for the service account in the Firebase console.")
  }
  return { projectId: json.project_id, clientEmail: json.client_email, privateKeyId: json.private_key_id || '' }
}

// A file's text, read in the browser.
export const readText = file => new Promise((resolve, reject) => {
  const reader = new FileReader()
  reader.onload = () => resolve(String(reader.result || ''))
  reader.onerror = () => reject(reader.error)
  reader.readAsText(file)
})
